import React from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material";
import Typography from "components/basic/typography";
import Button from "components/basic/button";

interface NoCoverageMessageProps {
  address: string;
  onChangeAddress: () => void;
}

/**
 * Shown on Select Estimate when no installer's service radius covers the
 * searched address, so the page is never just an empty band of colour.
 */
const NoCoverageMessage: React.FC<NoCoverageMessageProps> = ({
  address,
  onChangeAddress,
}) => {
  const theme = useTheme();
  const { t } = useTranslation("estimator");

  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        gap: theme.spacing(2),
        padding: theme.spacing(4),
      }}
    >
      <Typography
        style={{ fontWeight: "bold", fontSize: "2.2em" }}
        variant="h2"
        align="inherit"
      >
        {t("select.no_coverage_title")}
      </Typography>

      <Typography variant="body1" align="inherit">
        {address
          ? t("select.no_coverage_address", { address })
          : t("select.no_coverage")}
      </Typography>

      <Button
        style={{
          color: theme.palette.common.black,
          fontSize: "1.2em",
          fontWeight: "bold",
          padding: `0 ${theme.spacing(3.5)}`,
        }}
        variant="contained"
        color="secondary"
        onClick={onChangeAddress}
        size="large"
      >
        {t("select.change_address")}
      </Button>
    </div>
  );
};

export default NoCoverageMessage;
